import * as _ from "lodash";
import * as $ from "jquery";
import * as Backbone from "backbone";
import "select2";
import { Utils } from "../../../common/utils";
import { UserGroupCollection } from "../../../collections/UserGroups";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../_BaseModifyModal";
import { ModuleCollection } from "../../../collections/Modules";
import { DashboardWidgetCollection } from "../../../collections/DashboardWidgets";
import { DashboardCategoryCollection } from "../../../collections/DashboardCategories";

declare var App: any;
require('bootstrap-toggle');

interface BulkGenerateModalOptions extends BaseModifyModalViewOptions {
    dashboardId: number;
    dashboardCategoryCollection: DashboardCategoryCollection;
    dashboardWidgetCollection: DashboardWidgetCollection;
}

export class BulkGenerateModalView extends BaseModifyModalView {

    template = _.template(require('templates/modals/dashboard/bulkGenerate.html'));
    userGroupCollection: UserGroupCollection = null;
    options: BulkGenerateModalOptions;
    moduleCollection: ModuleCollection;
    installId: number;
    skipChooseModulesEvent = false;

    constructor(options: BulkGenerateModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #bulkGenerateModal': 'handleModalShown',
                'hidden.bs.modal #bulkGenerateModal': 'handleModalHidden',
                'click .bulk-generate-submit': 'handleSubmitButtonClick',
                'change .bulk-generate-select-install': 'handleInstallChange',
                'change .choose-modules-button': 'handleChooseModules',
                'change .module-checkbox': 'handleToggleModule',
            }
        }, options));

        // For the base class methods
        this.modalIdSelector = 'bulkGenerateModal';
    }

    render() {
        var db = this.options.dashboardCollection.findWhere({ id: this.options.dashboardId });
        var name = db.get('name');
        var orgId = db.get('organization_id');

        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            newDashboard: !this.options.dashboardId,
            dashboardId: this.options.dashboardId,
            permissionCollection: this.options.permissionCollection,
            name: name,
            organizationId: orgId,
            installCollection: this.options.installCollection,
            installId: this.installId
        }));

        // Select2 is causing a bug where it prevents you from scrolling inside the modal
        // after you've change your selection. We are disabling it as a temporary fix.
        // TODO: find a solution without disabling select2
        // this.$('.install-dropdown').find('select').select2(Utils.Select2.defaultOptions);

        // Style toggle buttons
        (<any>this.$('input[type="checkbox"]')).bootstrapToggle('on');

        // Initialize module options with spinner
        this.handleInstallChange();

        this.delegateEvents();
        return this;
    }

    private setLoading(loading: boolean) {
        this.$('.modules-loading').toggleClass('hidden', !loading);
        this.$('.modules-loaded').toggleClass('hidden', loading);
        this.$('.bulk-generate-submit').prop('disabled', loading);
    }

    private renderModuleRows() {
        this.setLoading(false);

        var rows = [];
        this.moduleCollection.each((module) => {
            // Exclude nodes with no (non-internal) sensors
            if (module.get('sensors').length < 2) return;

            var id = module.get('module_id');

            rows.push(
                '<tr data-module-id="' + id + '">' +
                '<td>' + _.escape(module.getDisplayName()) + '</td>' +
                '<td class="text-center">' +
                '<input type="checkbox" class="module-checkbox module-view" data-toggle="toggle" data-on="Include"' +
                ' data-off="Exclude" data-width="100" data-size="mini" ' + '></td>' +
                '</tr>'
            )
        });

        if (!rows.length) {
            rows.push(
                '<tr class="danger text-danger text-center">' +
                '<td colspan="4">' +
                'It looks like there are not any modules associated with ' +
                'this install. Try a different installation!' +
                '</td>' +
                '</tr>'
            )
        }

        this.$('tbody.modules-loaded').html(rows.join(''));
        (<any>this.$('.modules-loaded input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
    }

    handleInstallChange() {
        this.installId = Number(this.$('.bulk-generate-select-install').val());

        this.setLoading(true);
        this.moduleCollection = new ModuleCollection([], { installId: this.installId });
        $.when(this.moduleCollection.fetch()).done(() => {
            this.renderModuleRows();
            this.handleChooseModules();
        });
    }

    handleChooseModules() {
        const checked: boolean = this.$('.choose-modules-button').is(':checked');
        const toggles = (<any>this.$('input[type="checkbox"].module-checkbox'));
        if (!toggles) return;

        if (checked) {
            // Set all buttons to enabled
            this.$('.module-checkbox').each(function () {
                // Toggle on without triggering change event (silent = true)
                $(this).data('bs.toggle').on(true);
            })
        } else {
            this.$('.module-checkbox').each(function () {
                $(this).data('bs.toggle').off(true);
            })
        }
    }

    handleToggleModule() {
        const checkedBoxesCount = this.$('input[type="checkbox"].module-checkbox:checked').length;
        const allCheckboxCount = this.$('input[type="checkbox"].module-checkbox').length;
        const chooseModuleToggle = this.$('.choose-modules-button').data('bs.toggle');
        if (checkedBoxesCount === allCheckboxCount) {
            // Toggle on without triggering change event (silent = true)
            chooseModuleToggle.on(true);
        } else {
            chooseModuleToggle.off(true);
        }
    }

    handleSubmitButtonClick() {
        window['App'].Bus.trigger('dashboard:update:suspend');

        var data = {
            dashboardId: this.options.dashboardId,
            dashboardType: this.$('input[name=dashboardType]:checked').val(),
            initialCategoryOrder: 0,
            initialWidgetOrder: 0,
            installId: this.installId,
            moduleIds: []
        };

        _.each(this.$('.modules-loaded tr'), (tr) => {
            var moduleIsSelected = !$(tr).children('td').children().hasClass('off');
            if (moduleIsSelected) {
                var id = Number($(tr).attr('data-module-id'));
                data.moduleIds.push(id);
            }
        });

        if (!_.size(data.moduleIds)) return;

        // Set starting places for ordering categories and widgets
        var categories = this.options.dashboardCategoryCollection.models.slice(0, -1);
        data.initialCategoryOrder = _.size(categories) ? categories.slice(-1)[0].get('order') + 1 : 1;
        var widgets = this.options.dashboardWidgetCollection.models;
        data.initialWidgetOrder = _.size(widgets) ? widgets.slice(-1)[0].get('order') + 1 : 1;

        $.ajax({
            type: 'PUT',
            url: this.options.dashboardCollection.url() + '/' + this.options.dashboardId + '/bulk-generate',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.refetchCollectionsAndShowDashboard();
                window['App'].Bus.trigger('dashboard:update:resume');
            }
        });
    }

    refetchCollectionsAndShowDashboard() {
        var d1 = this.options.dashboardCollection.fetch({ reset: true });
        var d2 = this.options.permissionCollection.fetch({ reset: true });
        var d3 = this.options.dashboardChannelCollection.fetch({ reset: true });

        $.when(d1, d2, d3).done(() => {
            this.hide();
            Backbone.history.loadUrl();
        }).fail(() => {
            this.setFormError();
        })
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/BulkGenerateModal.ts